import useGetVehiclesLocations from '../../API/hooks/maps/useGetVehiclesLocations';
import { useGetVehicleLocationsByIds } from '../../API/hooks/maps/useGetVehicleLocations';
import useOngoingTripMapIds from '../../API/hooks/trips/useOngoingTripMapIds';
import S from './MapAlertsWidgetStyles';
import MapWidget from '../common/Map/Map';

function MapAlertsWidget({ fleetId, groupFilters }: { fleetId: string, groupFilters?: Record<string, any> }): JSX.Element {
  const { ongoingVehicleIds, ongoingTripSpeedDisplayByVehicleId } = useOngoingTripMapIds(fleetId);
  return (
    <S.Wrapper>
      <MapWidget
        fleetId={fleetId}
        entityType="vehicle"
        getLocationsQuery={useGetVehiclesLocations}
        getLocationDetailsQuery={useGetVehicleLocationsByIds}
        groupFilters={groupFilters}
        fleetOngoingVehicleIds={ongoingVehicleIds}
        ongoingTripSpeedDisplayByVehicleId={ongoingTripSpeedDisplayByVehicleId}
        showSpeedInVehicleInfo
      />
    </S.Wrapper>
  );
}

export default MapAlertsWidget;
